import { Avatar, Button, List, Space } from 'antd';
import React from 'react';
import clx from 'classnames';
import { TipoDatiSoggettiEnte } from 'server/schema/integrations/pdnd/schema/schemas';
import './PDNDResponseCitizenList.scss';
import { IconVector } from 'client/ui/icon/IconVector';
import { VerticalSpace } from 'client/ui/space/VerticalSpace';

interface IPDNDResponseCitizenListProps {
  citizens?: TipoDatiSoggettiEnte[] | undefined;
  onChargeCitizen: (citizen: TipoDatiSoggettiEnte) => void;
}

export function PDNDResponseCitizenList(props: IPDNDResponseCitizenListProps) {
  const { citizens, onChargeCitizen } = props;

  const multi = citizens && citizens.length > 1;
  if (!multi) return null;

  return (
    <div className="PDNDResponseCitizenList">
      <List
        size="small"
        header={<div>Lista Soggetti</div>}
        bordered
        itemLayout="horizontal"
        dataSource={citizens}
        renderItem={item => (
          <List.Item
            actions={[
              <Button
                onClick={() => {
                  onChargeCitizen(item);
                }}
              >
                Visualizza
              </Button>
            ]}
          >
            <List.Item.Meta
              avatar={
                <Avatar
                  className={clx('message-meta-avatar', {})}
                  children={<IconVector icon="Citizen" />}
                />
              }
              title={
                <Space size={24}>
                  <b>{item.generalita?.codiceFiscale?.codFiscale}</b>
                  {item.generalita?.nome}
                  {item.generalita?.cognome}
                </Space>
              }
            />
          </List.Item>
        )}
      />
      <VerticalSpace />
    </div>
  );
}
